import { atom } from 'recoil';

export const samplingAtom = atom({
  key: 'samplingAtom',
  default: {
    loading: false,
    item: null,
    item2: null,
    error: null
  },
});